module.exports = __webpack_public_path__ + "static/media/alert-circle-yellow.4e9e0523.svg";